import React from 'react';
import { useAuth } from '../AuthContext';

const AuthenticationFailure = () => {
    const {
        authenticationError,
        tryToVerifyToken,
        logout
    } = useAuth();

    return (
        <div className="flex items-center justify-center grow bg-center bg-no-repeat page-bg">
            <div className="card max-w-[420px] w-full">
                <div className="card-body flex flex-col gap-5 p-10" id="sign_in_form">
                    <div>
                        <div className="text-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
                            {authenticationError || 'An unknown error has occurred. Please try again.'}
                        </div>
                    </div>
                    <div className="text-center">
                        <h3 className="text-lg font-semibold text-gray-900 leading-none mb-2.5">
                            Failed to Authenticate
                        </h3>
                    </div>
                    {false && <div className="text-center text-gray-600 text-2sm">
                        {`Reference ${"emailAddress"} when contacting support.`}
                    </div>}
                    <div className='mb-2' />
                    <button
                        className="btn btn-primary flex justify-center grow"
                        type="button"
                        onClick={() => {
                            tryToVerifyToken();
                        }}
                    >
                        Retry
                    </button>
                    <button
                        className="btn btn-secondary flex justify-center grow"
                        type="button"
                        onClick={() => {
                            logout();
                        }}
                    >
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AuthenticationFailure;
